// extracted by mini-css-extract-plugin
module.exports = {"page":"SponsorList_page__3TE6y","mainTable":"SponsorList_mainTable__1qL4W"};